/* eslint-disable react-hooks/exhaustive-deps */
import PageWrapper from "components/pageWrapper";
import ProfileContext from "components/profileContext";
import posthog from "posthog-js";
import { useContext, useEffect } from "react";
import styles from "styles/pages/logout.module.scss";
import { isLocalhost, isSuperAdmin } from "utils/utils";

const Logout = () => {
  const { profile } = useContext(ProfileContext);
  useEffect(() => {
    localStorage.removeItem("sessionId_pulsy");
    if (!isLocalhost() && !isSuperAdmin(profile)) {
      posthog.reset();
    }
  }, []);
  return (
    <div>
      <PageWrapper>
        <div className={styles.content}>
          <h1 className={styles.title}>You've been successfuly logged out</h1>
        </div>
      </PageWrapper>
    </div>
  );
};

export default Logout;
